import { component$, Slot } from "@builder.io/qwik";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";

interface BuilderCardProps {
  title?: string;
  description?: string;
  fillHeight?: boolean;
}

export const BuilderCard = component$<BuilderCardProps>(
  ({ title, description, fillHeight }) => (
    <Card class={["flex flex-col", { "h-full": fillHeight }]}>
      {(title || description) && (
        <CardHeader>
          {title && <CardTitle>{title}</CardTitle>}
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>
      )}
      <CardContent class="flex grow flex-col gap-2">
        <Slot />
      </CardContent>
    </Card>
  ),
);
